// Must run before the route tree is imported so module-scope translations resolve.
import "./i18n";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { createRoot } from "react-dom/client";

import { initSentry } from "./monitoring/sentry";

import "./index.css";
import { routeTree } from "./routeTree.gen";

// Set up a Router instance
const router = createRouter({
  context: {
    permissions: undefined,
  },
  routeTree,
  defaultPreload: "intent",
  scrollRestoration: true,
});

// Register things for typesafety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);

initSentry();

if (!container.innerHTML) {
  root.render(<RouterProvider router={router} />);
}
